module.exports = __webpack_public_path__ + "static/media/6.ee2b05ed.png";